import * as THREE from 'three'
import Stage from 'components/Designer/Stage'

interface ColorType {
  r: number
  g: number
  b: number
}

interface SwatchType {
  crgb?: ColorType
  argb?: ColorType
  srgb?: ColorType
  matType?: string
  hex: string
  id: number
  name: string
}

interface SLibrary {
  [key: number]: Swatch
}

class SwatchLibrary {
  private _swatches: SLibrary = {}
  private _ids: number[] = []
  // private _initialized: boolean = false
  private static _instance: SwatchLibrary
  constructor() {}

  public static get instance() {
    if (!SwatchLibrary._instance) {
      SwatchLibrary._instance = new SwatchLibrary()
    }
    return SwatchLibrary._instance
  }

  public set initialize(e: SwatchType[]) {
    for (let i = 0; i < e.length; i++) {
      this.addSwatch = e[i]
    }
  }

  public set addSwatch({ hex, name, id }: SwatchType) {
    if (!this._ids.includes(id)) {
      const swatch = new Swatch({ hex, name, id })
      this._swatches[id] = swatch
      this._ids.push(id)
    }
  }

  public get swatches() {
    const result: Swatch[] = []
    for (let swatch in this._swatches) {
      // console.log(swatch)
      result.push(this._swatches[swatch])
    }
    return result
  }

  public get indexedSwatches() {
    const count = 5
    const ids: number[] = []
    for (let i = 0; i < count; i++) {
      const newId = Math.round(Math.random() * this._ids.length)
      if (!ids.includes(newId) && this._ids.includes(newId)) {
        ids.push(newId)
      } else {
        i--
      }
    }
    ids.sort((a, b) => a - b)
    const swatches: Swatch[] = []
    for (let i of ids) {
      // for (let i of [0, 0, 0, 0, 0]) {
      swatches.push(this._swatches[i])
    }
    return swatches
  }

  public getSwatch(i: number): Swatch {
    return this._swatches[i]
  }
}

const loadingManager = new THREE.LoadingManager()
const loaderTexture = new THREE.TextureLoader(loadingManager)

const defLeatherNormals = loaderTexture.load('/material/leather/01.jpg')
defLeatherNormals.wrapS = THREE.RepeatWrapping
defLeatherNormals.wrapT = THREE.RepeatWrapping
defLeatherNormals.repeat.set(0.6, 0.6)

class Swatch {
  private _crgb: ColorType
  private _color: THREE.Color
  private _name: string
  private _id: number

  // NOTE: Hardcoded leather values
  private _roughness: number = 0.45
  private _metalness: number = 0
  private _normalScale: THREE.Vector2 = new THREE.Vector2(1.3, 1.3)
  private _normalMap: THREE.Texture

  constructor({ hex, name, id }: SwatchType) {
    this._name = name
    this._id = id
    this._color = new THREE.Color(`${hex}`)
    const { r, g, b } = this._color
    this._crgb = { r, g, b }
    this._normalMap = defLeatherNormals
  }

  public get color() {
    return this._color
  }

  public get hex(): string {
    return '#' + this._color.getHexString()
  }

  public get id() {
    return this._id
  }

  public get data() {
    return {
      name: this._name,
      hex: this.hex,
      id: this._id,
      color: this._color,
    }
  }

  public get matData() {
    return {
      roughness: this._roughness,
      metalness: this._metalness,
      normalScale: this._normalScale,
      normalMap: this._normalMap,
      color: this._color,
    }
  }
}

export default Swatch
export { SwatchLibrary }
